import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { formatRecurrenceText } from 'src/components/AvailabilitySelectorExactTime/AvailabilitySelectorExactTime.utils';
import repeatingCalendar from 'src/images/repeating-calendar.svg';
import styles from './styles.scss';

/** @param {{order: Order}} */
export const RecurrencePattern = ({ order, className }) => {
  const recurrenceText = order.recurringService?.recurrenceText;

  if (!recurrenceText) return null;

  const formattedRecurrenceText = formatRecurrenceText({
    recurrenceText,
    prefix: 'Repeats',
    options: { downcaseRecurrence: true },
  });

  return (
    <div className={cn(styles.recurrencePattern, className)}>
      <img src={repeatingCalendar} className={styles.recurringCalendarIcon} />
      <p className={'caption text-weight-med'}>{formattedRecurrenceText}</p>
    </div>
  );
};

// ###########
// PROP TYPES
// ###########

RecurrencePattern.propTypes = {
  order: PropTypes.object.isRequired,
  className: PropTypes.string,
};

/** @typedef {import ('src/types/order').Order} Order */
